


















import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useLoadCalls, useIsPage } from '~/composables';
import { ROUTES } from '~/constants/routes';
import { getSlugForRoute } from '~/helpers/routes/getPageInformation';

export default defineComponent({
  name: 'BaseLayout',
  components: {
    ExtraGuaranteeSidebar: () => import(/* webpackChunkName: "ExtraGuaranteeSidebar" */
      '~/components/organisms/ExtraGuarantee/ExtraGuaranteeSidebar.vue'),
  },
  setup(_props, { root: { $route } }) {
    useLoadCalls();
    const { isOnPaymentPage } = useIsPage();

    const layoutClass = computed(() => {
      if ([getSlugForRoute(ROUTES.CHECKOUT_ADDRESSES),
        getSlugForRoute(ROUTES.CHECKOUT_PAYMENT),
        getSlugForRoute(ROUTES.THANK_YOU),
      ].includes($route.fullPath)) {
        return 'container m-auto';
      } else {
        return 'full-width';
      }
    });

    return {
      layoutClass,
      isOnPaymentPage,
    };
  },
});
